export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_16.98ae901b.jpg";